
import SvgIcon from "@/components/common/SvgIcon.vue"
import {computed, ref, watchEffect} from "vue";
import store from "@/store";
import {getVICPrefix} from "@/utils/general";
const vicBg = require("@/assets/image/bg-vic3.png");
const bvicBg = require("@/assets/image/bg-bvic3.png");
const tvicBg = require("@/assets/image/bg-tvic3.png");

export default {
  name: 'MemberHeader',
  components: {SvgIcon},
  setup() {
    const type = computed(() => store.state.selectedType);
    const headerBg = ref('');
    const headerLogo = ref('');

    watchEffect(() => {
      const prefix = getVICPrefix(type.value).toLowerCase();
      headerBg.value = `bg-${prefix}vic-login`;
      headerLogo.value = `logo-${prefix}vic`;
    });

    return {
      type,
      vicBg,
      bvicBg,
      tvicBg,
      headerBg,
      headerLogo,
      getVICPrefix,
    }
  }
}
